import { postCommonConfigGetNoticeList } from '@/services/yizhe-web/gonggongfenlei';
import { NotificationOutlined } from '@ant-design/icons';
import { ProList } from '@ant-design/pro-components';
import { useModel } from '@umijs/max';
import { Badge, Button, Modal, Tag } from 'antd';
import { useRef, useState } from 'react';
import './index.less';
import NoticeDetail from './NoticeDetail';

const ModalNotice = () => {
  const { initialState } = useModel('@@initialState');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const actionRef = useRef<any>(null);
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Badge
        size="small"
        count={initialState?.redNum?.notice_red_num}
        overflowCount={99}
        style={{ marginRight: 10 }}
      >
        <Button
          shape="round"
          key="modal-notice"
          style={{ color: '#666666' }}
          icon={<NotificationOutlined style={{ color: '#666666' }} />}
          onClick={() => {
            setIsModalOpen(true);
          }}
          size="small"
        >
          公告
        </Button>
      </Badge>
      <Modal
        title="公告列表"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="关闭"
        width={600}
        footer={null}
        className="modalform-fixed"
      >
        <ProList<any>
          className="modal-notice-list"
          split={true}
          actionRef={actionRef}
          request={async (params: any) => {
            const { data } = await postCommonConfigGetNoticeList({
              ...params,
              page: params?.current,
              page_size: params?.pageSize,
            });
            return {
              data: data?.list || [],
              success: true,
              current: data.page,
              pageSize: data.page_size,
              total: data.total,
            };
          }}
          pagination={{
            defaultPageSize: 10,
          }}
          rowKey="notice_id"
          metas={{
            title: {
              dataIndex: 'show_at',
              render: (text, row) => {
                return (
                  <NoticeDetail
                    data={row}
                    key="view"
                    btnText={text}
                    update={() => {
                      actionRef.current?.reload();
                    }}
                  />
                );
              },
            },
            subTitle: {
              render: (_: any, record: any) => {
                return <>{record?.is_new ? <Tag color="#f93232">New</Tag> : null}</>;
              },
            },
            description: {
              dataIndex: 'summary',
              render: (_: any) => {
                return <div dangerouslySetInnerHTML={{ __html: _ }} />;
              },
            },
            actions: {
              render: (text, row) => [
                <NoticeDetail
                  data={row}
                  key="view"
                  update={() => {
                    actionRef.current?.reload();
                  }}
                />,
              ],
            },
          }}
        />
      </Modal>
    </>
  );
};
export default ModalNotice;
